<div *ngIf='{ desktop: (deviceS.isDesktop$|async),
              mobile: (deviceS.isMobile$|async),
             } as obj'
     class='t-actionsItemTable t-actionsItemTable--{{obj.desktop}}'
     [class.o-opacity]='disabled'
     ceilTable [idxCeil]='meTableS.arrWidthCeilTable.length - 1'>
  <!--[matMenuTriggerFor]='menuItemTable'-->
  <!--<meSvg [svgName]='meTableS.svgNameForActions' ceilTable [idxCeil]='meTableS.arrWidthCeilTable.length - 1'></meSvg>-->
  <meSvg [svgName]='meTableS.svgNameForActions' [cur]='!disabled'></meSvg>
</div>